// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3lG5K","header":"Messages_header__2ie-7"};